// TemplateFiles.tsx
import React from "react"
import { List } from "antd"
import { TemplateFileListResult, SelectedFile } from "types/template.types"

// Define the props interface for TemplateFiles
interface TemplateFilesProps {
  /** An object containing public and private template file arrays */
  templateFiles: TemplateFileListResult
  /** Callback function that is called when a template file is clicked */
  onItemClick: (item: SelectedFile) => void
}

/**
 * TemplateFiles component displays a list of available template files,
 * allowing the user to select a template for further actions.
 *
 * @param props - The component props
 * @returns The rendered TemplateFiles component
 */
const TemplateFiles: React.FC<TemplateFilesProps> = ({
  templateFiles,
  onItemClick,
}) => {
  // Create objects with filename and type for each template
  const sharedTemplates: SelectedFile[] = templateFiles.public.map(
    (filename: string) => ({
      template: filename,
      type: "public",
    })
  )

  const unitTemplates: SelectedFile[] = templateFiles.private.map(
    (filename: string) => ({
      template: filename,
      type: "private",
    })
  )

  // Combine the two arrays into one
  const allTemplates: SelectedFile[] = [...sharedTemplates, ...unitTemplates]

  return (
    <div className="flex flex-col">
      <List
        itemLayout="horizontal"
        dataSource={allTemplates}
        renderItem={(item: SelectedFile, index: number) => (
          <List.Item
            key={index}
            className="cursor-pointer hover:bg-gray-200 rounded-md border mb-1 shadow-sm"
            onClick={() => onItemClick(item)}
          >
            <List.Item.Meta
              className="p-2 text-center font-semibold"
              title={`${item.type} - ${item.template}`}
            />
          </List.Item>
        )}
      />
    </div>
  )
}

export default TemplateFiles
